module.exports = __webpack_public_path__ + "img/logo.b5913991.svg";